import { render, staticRenderFns } from "./StepTeachers.vue?vue&type=template&id=0afecf78&scoped=true&"
import script from "./StepTeachers.vue?vue&type=script&lang=js&"
export * from "./StepTeachers.vue?vue&type=script&lang=js&"
import style0 from "./StepTeachers.vue?vue&type=style&index=0&id=0afecf78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afecf78",
  null
  
)

export default component.exports